import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { supabase } from "../supabaseClient";
import "./Navbar.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [authed, setAuthed] = useState(false);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const loc = useLocation();

  // Load auth state & subscribe to changes
  useEffect(() => {
    let mounted = true;

    supabase.auth.getUser().then(({ data }) => {
      if (!mounted) return;
      const user = data?.user;
      setAuthed(!!user);
      setEmail(user?.email || "");
    });

    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      const user = session?.user;
      setAuthed(!!user);
      setEmail(user?.email || "");
    });

    return () => {
      mounted = false;
      sub?.subscription?.unsubscribe?.();
    };
  }, []);

  const logout = async () => {
    await supabase.auth.signOut();
    navigate("/");
  };

  const linkClass = ({ isActive }) => (isActive ? "is-active" : undefined);

  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [loc.pathname]);

  return (
    <header className={`navbar ${isOpen ? "show" : ""}`}>
      {/* Brand */}
      <div className="navbar-logo">
        <div className="logo-mark" />
        <Link to="/">Taren by GK Technologies</Link>
      </div>

      {/* Mobile toggle */}
      <button
        className="navbar-toggle"
        aria-label="Toggle navigation"
        onClick={() => setIsOpen((v) => !v)}
      >
        ☰
      </button>

      {/* Links */}
      <nav className="navbar-links">
        <NavLink to="/" className={linkClass}>Home</NavLink>
        {/* Anchor links assume IDs exist on the landing page (see note below) */}
        <a href="/#features">Features</a>
        <a href="/#pricing">Pricing</a>
        {authed ? (
          <>
            <NavLink to="/dashboard" className={linkClass}>Dashboard</NavLink>
            <button className="logout-button" onClick={logout}>
              Logout{email ? ` (${email.split("@")[0]})` : ""}
            </button>
          </>
        ) : (
          <>
            <NavLink to="/auth?mode=login" className={linkClass}>Sign in</NavLink>
            <Link to="/auth?mode=signup" className="navbar-cta">Get started</Link>
          </>
        )}
      <Link to="/about">About</Link>
      </nav>
    </header>
  );
}
